// TODO: build this out to handle all of https://developers.cloudflare.com/images/url-format
interface IResizedImage {
  /** Specifies maximum width of the image in pixels. Exact behavior depends on the fit mode (described below). */
  height?: number | null;
  /** Specifies maximum height of the image in pixels. Exact behavior depends on the fit mode (described below). */
  width?: number | null;
  /** Specifies quality for images in JPEG, WebP and AVIF formats. The quality is in 1-100 scale, but useful values are between 50 (low quality, small file size) and 90 (high quality, large file size). 85 is the default. When using the PNG format, an explicit quality setting allows use of PNG8 (palette) variant of the format. */
  quality?: number | null;
  /** Affects interpretation of width and height. All resizing modes preserve aspect ratio. Available modes are: */
  fit?: 'scale-down' | 'contain' | 'cover' | 'crop' | 'pad' | null;
  /** When cropping with fit=cover, specifies the most important side or point in the image that shouldn’t be cropped off. */
  gravity?: string | null;
  className?: string;
  source?: string | null;
  domain?: string | null;
  altText?: string | null;
  loading?: 'lazy' | 'eager';
}

export const ResizedImage = ({
  height,
  width,
  quality,
  fit,
  gravity,
  altText,
  source,
  domain,
  className,
  loading = 'lazy',
}: IResizedImage) => {
  const options = [];

  if (height) {
    options.push(`height=${height}`);
  }

  if (width) {
    options.push(`width=${width}`);
  }

  if (quality) {
    options.push(`quality=${quality}`);
  }

  if (fit) {
    options.push(`fit=${fit}`);
  }

  if (gravity) {
    options.push(`gravity=${gravity}`);
  }

  if (!source) {
    return (
      <img
        alt={altText || 'On3 image'}
        {...(width ? { width } : {})}
        {...(height ? { height } : {})}
        className={className}
        src={`https://on3static.com/cdn-cgi/image/${options.join(
          ',',
        )}/static/on3/on3-default.jpg`}
      />
    );
  }

  const path = source.replace(/^\//, '') || 'static/on3/on3-default.jpg';
  const newDomain = `https://${domain || 'on3static.com'}/`;

  let newSource = '';

  if (domain !== 'on3static.com') {
    newSource = `https://${domain}/${source}`;
  } else {
    newSource =
      options.length === 0
        ? `${newDomain}${path}`
        : `${newDomain}cdn-cgi/image/${options.join(',')}/${path}`;
  }

  return (
    <img
      alt={altText || 'On3 image'}
      {...(width ? { width } : {})}
      {...(height ? { height } : {})}
      className={className}
      loading={loading}
      src={newSource}
    />
  );
};
